import { SIGNATURE_ENUM } from '@/shared/config';
import { t } from 'ttag';

const SIGNATURE_OPTION = {
  [SIGNATURE_ENUM.STANDARD]: t`Anyone can sign (Cost $2.00+)`,
  [SIGNATURE_ENUM.ADULT]: t`An adult must sign (Cost $5.00+)`,
};

export { SIGNATURE_OPTION };
